import React, { useContext } from "react";
import { MainContext } from "../App";

function Shops() {
	const { shops, setShop, setTable, user, setUser } = useContext(MainContext);
	const isAdmin = parseInt(user?.role?.admin) === 1;
	const hasShops = Array.isArray(shops) && shops.length > 0;
	const showNoAssociatedShopFallback = !isAdmin && Array.isArray(shops) && shops.length === 0;

	const handleBack = () => {
		localStorage.removeItem("waiter-user");
		setTable(false);
		setShop(false);
		setUser(false);
	};

	return (
		<div className="popup full-back">
			<div className="container shops-list">
				<header>
					<div className="title">Selziona il negozio</div>
				</header>
				<div className="content">
					{hasShops &&
						shops.map((shop, i) => (
							<button
								onClick={() => {
									setTable(false);
									setShop(shop);
								}}
								key={i}
								className="list-button"
								disabled={!!shop.license_expired}
							>
								{shop.name}
								{shop.license_expired ? " (licenza scaduta)" : ""}
							</button>
						))}
						{showNoAssociatedShopFallback && (
							<div className="shops-empty-state-wrap">
								<div className="shops-empty-state">
									<div className="shops-empty-state-title">
										Nessun negozio associato a questo operatore
									</div>
									<div className="shops-empty-state-subtitle">
										Contatta l&apos;amministratore
									</div>
									<button
										className="btn btn-tertiary shops-empty-state-back"
										onClick={handleBack}
									>
										Indietro
									</button>
								</div>
							</div>
						)}
				</div>
			</div>
		</div>
	);
}

export default Shops;
